<mat-expansion-panel
  class="product-progress"
  expanded="true"
  hideToggle
  disabled
  >
  <div class="product-progress__content">
    @for (item of config; track item; let i = $index) {
      @if (i !== 0 && !item.hidden) {
        <div
          class="product-progress__spacer"
          [ngClass]="{ active: indexActive >= i }"
        ></div>
      }
      @if (!item.hidden) {
        <div
          class="product-progress__step"
          [ngClass]="{ active: activeStep === item.id, disabled: indexActive < i }"
          (click)="onChange(item.id)"
          >
          <div
            class="product-progress__step-icon"
            [ngClass]="{ active: activeStep === item.id }"
            >
            <div>{{ i + 1 }}</div>
          </div>
          <h3>{{ item.label }}</h3>
        </div>
      }
    }
  </div>
</mat-expansion-panel>
